import React from 'react';
import { motion } from 'framer-motion';
import { X, Check } from 'lucide-react';
const sinMetodo = ['Actividades aburridas.', 'Falta de motivación.', 'Distracciones constantes.', 'Poco avance.', 'Frustración.'];
const conMetodo = ['Aprendizaje divertido.', 'Más atención.', 'Mayor motivación.', 'Mejor escritura.', 'Más confianza.'];
export function ComparisonSection() {
  return <section className="py-20 bg-slate-50" data-id="element-1">
      <div className="container mx-auto px-6 max-w-5xl" data-id="element-2">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-3">
          {/* SIN EL MÉTODO */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-white rounded-3xl p-8 shadow-sm border border-slate-100" data-id="element-4">
            <div className="text-center mb-8" data-id="element-5">
              <div className="inline-block px-4 py-1.5 bg-pastel-coralLight text-pastel-coral font-bold rounded-full text-sm mb-4" data-id="element-6">
                SIN EL MÉTODO
              </div>
            </div>
            <ul className="flex flex-col gap-6" data-id="element-7">
              {sinMetodo.map((item, i) => <li key={i} className="flex items-center gap-4" data-id="element-8">
                  <div className="w-8 h-8 rounded-full bg-pastel-coralLight flex items-center justify-center shrink-0" data-id="element-9">
                    <X className="w-5 h-5 text-pastel-coral" data-id="element-10" />
                  </div>
                  <span className="text-lg text-slate-600 font-medium" data-id="element-11">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>

          {/* CON EL MÉTODO */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-pastel-mintLight/30 rounded-3xl p-8 shadow-lg border border-pastel-mint relative overflow-hidden" data-id="element-12">
            <div className="absolute top-0 right-0 w-32 h-32 bg-pastel-mint opacity-20 rounded-bl-full" data-id="element-13" />
            <div className="text-center mb-8 relative z-10" data-id="element-14">
              <div className="inline-block px-4 py-1.5 bg-pastel-mint text-slate-800 font-bold rounded-full text-sm mb-4 shadow-sm" data-id="element-15">
                CON EL MÉTODO
              </div>
            </div>
            <ul className="flex flex-col gap-6 relative z-10" data-id="element-16">
              {conMetodo.map((item, i) => <li key={i} className="flex items-center gap-4" data-id="element-17">
                  <div className="w-8 h-8 rounded-full bg-pastel-mint flex items-center justify-center shrink-0 shadow-sm" data-id="element-18">
                    <Check className="w-5 h-5 text-white" data-id="element-19" />
                  </div>
                  <span className="text-lg text-slate-800 font-bold" data-id="element-20">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}